// extracted by mini-css-extract-plugin
export default {"simplePanelLayout":"OrderMessagingPanel_simplePanelLayout__juQY+"};